// import * as Sentry from '@sentry/react';
import type { ApiError } from '@/types/api'; // Your defined ApiError interface

/**
 * Sends a structured API error to Sentry for monitoring.
 * @param error - The structured ApiError object.
 * @param user - Optional user information.
 */
export function logToMonitoringService(
  error: ApiError,
  user?: { id: string; email: string }
): void {
  console.log(`Implement monitoring: ${error.message}; ${user ? user?.id : 'anonymous'}`)
  // Sentry.withScope(scope => {
  //   // Add tags for easy searching and filtering in Sentry
  //   scope.setTag("errorCode", error.errorCode);
  //   scope.setTag("statusCode", error.statusCode);

  //   // Set the user context if available
  //   if (user) {
  //     scope.setUser(user);
  //   }

  //   // Add the full error object and other relevant data as structured context
  //   scope.setContext("API Error Details", {
  //     "Trace ID": error.traceId,
  //     "Full Error": error.details,
  //   });

  //   // Set the "level" of the issue (e.g., error, warning, info)
  //   scope.setLevel("error");

  //   // Capture the exception with a descriptive message
  //   Sentry.captureException(new Error(error.message), {
  //     extra: {
  //       // You can add any extra unstructured data here if needed
  //       apiErrorObject: error,
  //     }
  //   });
  // });
}
